import { Component, Input, ViewChild } from '@angular/core';
import { StylesSmartTableComponent } from '@brafton/angular-styles-library';
import { IBase, IBaseHasParent, IBaseProject, IPagedList } from '@brafton/common-framework-library';

@Component({
  selector: 'shared-pending-projects-listing',
  templateUrl: './pending-projects-listing.component.html',
  styleUrls: ['./pending-projects-listing.component.scss'],
  host: { class: 'pending-projects-listing' },
})
export class SharedPendingProjectsListingComponent {
  @Input() pendingProjects!: IPagedList<IBaseProject>;
  @Input() showDate!: boolean;
  @Input() showUnits!: boolean;
  @Input() showOwner!: boolean;
  @Input() showContentType!: boolean;
  @Input() showStatus!: boolean;
  @Input() showOrganization!: boolean;
  @Input() showActions!: boolean;
  @Input() showInstanceType!: boolean;
  @Input() showColumnHeaders = true;
  @ViewChild('smartTable') smartTable!: StylesSmartTableComponent<any>;

  buildMainColumns(): string[] {
    const columns = ['title'];

    if (this.showOrganization === true) columns.push('organization');

    if (this.showInstanceType === true) columns.push('instanceType');

    if (this.showDate === true) columns.push('startDate');

    if (this.showDate === true) columns.push('endDate');

    if (this.showContentType === true) columns.push('contentType');

    if (this.showStatus === true) columns.push('status');

    if (this.showUnits === true) columns.push('units');

    if (this.showActions === true) columns.push('actions');

    return columns;
  }

  isMulti(proj: IBaseProject): boolean {
    if ((proj as unknown as IBaseHasParent).parent.type.includes('Multi')) {
      return true;
    }
    return false;
  }

  resolveLine(proj: IBaseProject): IBase {
    if ((proj as unknown as IBaseHasParent).parent.type.includes('Multi')) {
      return (proj as unknown as IBaseHasParent).parent;
    }
    return proj;
  }

  resolveParentProject(pending: IBaseProject): IBaseProject {
    if ((pending as unknown as IBaseHasParent).parent.type.includes('Multi')) {
      return ((pending as unknown as IBaseHasParent).parent as unknown as IBaseHasParent).parent as IBaseProject;
    }
    return (pending as unknown as IBaseHasParent).parent as IBaseProject;
  }
}
